/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  WebApiCustomListsDtoChangeCustomListItemMembersDto,
  WebApiCustomListsDtoCreateBulkCustomListDto,
  WebApiCustomListsDtoCreateCustomListItemDto,
  WebApiCustomListsDtoCustomListItemDto,
  WebApiCustomListsDtoUpdateCustomListItemDto,
} from '../models';
import {
    WebApiCustomListsDtoChangeCustomListItemMembersDtoFromJSON,
    WebApiCustomListsDtoChangeCustomListItemMembersDtoToJSON,
    WebApiCustomListsDtoCreateBulkCustomListDtoFromJSON,
    WebApiCustomListsDtoCreateBulkCustomListDtoToJSON,
    WebApiCustomListsDtoCreateCustomListItemDtoFromJSON,
    WebApiCustomListsDtoCreateCustomListItemDtoToJSON,
    WebApiCustomListsDtoCustomListItemDtoFromJSON,
    WebApiCustomListsDtoCustomListItemDtoToJSON,
    WebApiCustomListsDtoUpdateCustomListItemDtoFromJSON,
    WebApiCustomListsDtoUpdateCustomListItemDtoToJSON,
} from '../models';

export interface BulkCreatePostRequest {
    webApiCustomListsDtoCreateBulkCustomListDto?: WebApiCustomListsDtoCreateBulkCustomListDto;
}

export interface CreatePostRequest {
    webApiCustomListsDtoCreateCustomListItemDto?: WebApiCustomListsDtoCreateCustomListItemDto;
}

export interface CustomListItemIdMembersPostRequest {
    customListItemId: number;
    webApiCustomListsDtoChangeCustomListItemMembersDto?: WebApiCustomListsDtoChangeCustomListItemMembersDto;
}

export interface IdDeleteRequest {
    id: number;
}

export interface ListCustomListIdGetRequest {
    customListId: number;
}

export interface UpdateIdPostRequest {
    id: number;
    webApiCustomListsDtoUpdateCustomListItemDto?: WebApiCustomListsDtoUpdateCustomListItemDto;
}

/**
 * 
 */
export class CustomListItemApi extends runtime.BaseAPI {

    /**
     */
    async bulkCreatePostRaw(requestParameters: BulkCreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/bulk-create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoCreateBulkCustomListDtoToJSON(requestParameters.webApiCustomListsDtoCreateBulkCustomListDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bulkCreatePost(requestParameters: BulkCreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bulkCreatePostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createPostRaw(requestParameters: CreatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListItemDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoCreateCustomListItemDtoToJSON(requestParameters.webApiCustomListsDtoCreateCustomListItemDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async createPost(requestParameters: CreatePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListItemDto> {
        const response = await this.createPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async customListItemIdMembersPostRaw(requestParameters: CustomListItemIdMembersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListItemDto>> {
        if (requestParameters.customListItemId === null || requestParameters.customListItemId === undefined) {
            throw new runtime.RequiredError('customListItemId','Required parameter requestParameters.customListItemId was null or undefined when calling customListItemIdMembersPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/{customListItemId}/members`.replace(`{${"customListItemId"}}`, encodeURIComponent(String(requestParameters.customListItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoChangeCustomListItemMembersDtoToJSON(requestParameters.webApiCustomListsDtoChangeCustomListItemMembersDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async customListItemIdMembersPost(requestParameters: CustomListItemIdMembersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListItemDto> {
        const response = await this.customListItemIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async idDeleteRaw(requestParameters: IdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling idDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async idDelete(requestParameters: IdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.idDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async listCustomListIdGetRaw(requestParameters: ListCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WebApiCustomListsDtoCustomListItemDto>>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling listCustomListIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/list/{customListId}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WebApiCustomListsDtoCustomListItemDtoFromJSON));
    }

    /**
     */
    async listCustomListIdGet(requestParameters: ListCustomListIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WebApiCustomListsDtoCustomListItemDto>> {
        const response = await this.listCustomListIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateIdPostRaw(requestParameters: UpdateIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WebApiCustomListsDtoCustomListItemDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateIdPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/update/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WebApiCustomListsDtoUpdateCustomListItemDtoToJSON(requestParameters.webApiCustomListsDtoUpdateCustomListItemDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WebApiCustomListsDtoCustomListItemDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateIdPost(requestParameters: UpdateIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WebApiCustomListsDtoCustomListItemDto> {
        const response = await this.updateIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
